<div class="layout-footer">
    <div class="footer-end">
        <span>{{name}} - © disroSoft {{date | date:'yyyy'}} - {{version}} | <small>{{uuid}}</small></span>
    </div>
</div>
